import React from 'react'
import ReactDOM from 'react-dom'
import { BrowserRouter } from 'react-router-dom'
import * as App from './App'
import './styles/global.css'

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
      <App.default />
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById('root'),
)
